/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

export const useSyncScreenData = (
  screenData,
  dataSetter,
  localStorageKey,
  nextRout = null,
  extraValues = null,
) => {
  const history = useHistory();

  useEffect(() => {
    if (screenData.data && !screenData.loading && screenData.statusCode) {
      if (screenData.statusCode === 200) {
        localStorage.setItem(localStorageKey, JSON.stringify(screenData.data));
        if (extraValues) {
          dataSetter({ ...screenData.data, ...extraValues });
        } else {
          dataSetter(screenData.data);
        }
        screenData.resetResult();
        if (nextRout) {
          history.push(nextRout);
        }
      }
    }
  }, [screenData]);
};
